import { createNetworkActions } from "~/utils/actions";

export default {
	...createNetworkActions("SAMTYKKE_TEXTS"),
};
